// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__tOODZ","header":"ClearentDisclaimer_header__KpCKi","inner":"ClearentDisclaimer_inner__3rrAB"};